/* APP STATUS CONSTANTS */
export const ERROR_GENERIC = 'generic_error';
export const ERROR_NOT_FOUND = 'not_found';
export const ERROR_PERMISSION_DENIED = 'permission_denied';
